import { createFileRoute } from '@tanstack/react-router'
import ContatoDetailPage from '@/pages/contatos/contato-detail'

// Rota index para /dashboard/$dashboardId/contatos/$id
// Renderizada quando acessar diretamente /dashboard/$dashboardId/contatos/$id
// Sem rota filha ativa
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/contatos/$id/',
)({
  component: function ContatoDetailRoute() {
    const { dashboardId, id } = Route.useParams()
    return <ContatoDetailPage contatoId={id} dashboardId={dashboardId} />
  },
})
